import { DriveParameters } from "../../pages/DriveParameters";

/**
 * Thin mobile wrapper. The desktop page already uses `flex-col` with
 * `max-md:` overrides for the chip row and PlotCard caps plot height
 * on phones (see PlotCard.tsx:29). When mobile-specific tweaks are
 * needed, fork the body here rather than touching the desktop file.
 */
export function MobileDriveParameters() {
  return <DriveParameters />;
}
